"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useGetDescendantIdByActivityKey;

var _useContext = _interopRequireDefault(require("./private/useContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useGetDescendantIdByActivityKey() {
  return (0, _useContext.default)().getDescendantIdByActivityKey;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VHZXREZXNjZW5kYW50SWRCeUFjdGl2aXR5S2V5IiwidXNlVHJhbnNjcmlwdEZvY3VzQ29udGV4dCIsImdldERlc2NlbmRhbnRJZEJ5QWN0aXZpdHlLZXkiXSwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9wcm92aWRlcnMvVHJhbnNjcmlwdEZvY3VzL3VzZUdldERlc2NlbmRhbnRJZEJ5QWN0aXZpdHlLZXkudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHVzZVRyYW5zY3JpcHRGb2N1c0NvbnRleHQgZnJvbSAnLi9wcml2YXRlL3VzZUNvbnRleHQnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiB1c2VHZXREZXNjZW5kYW50SWRCeUFjdGl2aXR5S2V5KCk6IChhY3Rpdml0eUtleT86IHN0cmluZykgPT4gc3RyaW5nIHwgdW5kZWZpbmVkIHtcbiAgcmV0dXJuIHVzZVRyYW5zY3JpcHRGb2N1c0NvbnRleHQoKS5nZXREZXNjZW5kYW50SWRCeUFjdGl2aXR5S2V5O1xufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7Ozs7QUFFZSxTQUFTQSwrQkFBVCxHQUF5RjtFQUN0RyxPQUFPLElBQUFDLG1CQUFBLElBQTRCQyw0QkFBbkM7QUFDRCJ9